import React from "react";
import ChangeAlbeHeader from "./ChangeAbleHeader";
// import "../components/componentstyle/gelleryData.css";

function SharedEventGallery({ className, title }) {
  const images = [
    {
      image: require("../assets/recent-img1.jpg"),
      text: "Slide 1 description...",
    },
    {
      image: require("../assets/recent-img2.jpg"),
      text: "Slide 2 description...",
    },
    {
      image: require("../assets/recent-img3.jpg"),
      text: "Slide 3 description...",
    },
    {
      image: require("../assets/recent-img4.jpg"),
      text: "Slide 3 description...",
    },
    {
      image: require("../assets/recent-img5.jpg"),
      text: "Slide 3 description...",
    },
    {
      image: require("../assets/recent-img6.jpg"),
      text: "Slide 3 description...",
    },
  ];

  return (
    <div>
     <ChangeAlbeHeader>{title}</ChangeAlbeHeader>
      <div className="event-wrapper pt-5">
        <div className="image-event-wrapper container">
          <div className="row">
            {images.map((img, index) => (
              <div className="event-card col-lg-4 col-md-6 col-12" key={index}>
                <div
                  className={`${className} ${className}-imgeDiv hover-wrapper`}
                >
                  <img
                    src={img.image}
                    alt=""
                    className={`${className}hover-image `}
                  />
                  <div className={`${className}hover-overlay`}>
                    <span>Multigrain</span>
                  </div>
                </div>

                <div className={`${className}-hide d-flex gap-4`}>
                  <p className={`${className}-hide txt`}>Recent Event Detail</p>
                  <div className={`${className}-hide event-underline`}></div>
                </div>

                <p className={`${className}-hide txtdesc`}>{img.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SharedEventGallery;
